import config from "../config.js";
import RequestManager from "./request.js";

export default class Contrat{
    id;
    ADELI;
    email;
    idtypecontrat;
    nom;
    prenom;
    tel;
    adresse1;
    adresse2;
    ville;
    code_postal;
    nombre_de_postes;
    debut_contrat;
    dateDeFinDansBD;
     fin_contrat  
    dateDeDebutDePeriode;
     dateDeFinDePeriode  
    listAttribut;
    nbAttribut;
    debut_periode;
    fin_periode;
    etat_contrat;
    Chemin_icone_provisoire;
    Chemin_icone;
    constructor(obj) {

    }
    static getContratById(id) {
        if (id == null) {
            console.warn("ID == null");
            return Promise.resolve({});
        }
        else {
            var url = encodeURI(config.urlBackEnd + "api/Contrat/getContratById/" + id);
            return RequestManager.get(url);
        }
    }
}
